export function Styles() {
  this.colors = {
    planning: '#00b0f0',
    red: '#e00000',
    faintred: '#ff7070',
    blue: '#0000ff',
    green: '#009000',
    darkred: '#500000',
    darkblue: '#000050',
    midgrey: '#a0a0a0',
    darkgrey: '#606060',
    black: '#000000',
    orange: '#FF844E',
  };
  this.vertexIcon = {
    externalGraphic: 'assets/img/handle2.png',
    graphicWidth: 16,
    graphicHeight: 16,
    graphicOpacity: 0.1,
    cursor: 'pointer',
  };
  this.augment = function (style, scol, swidth, fopac, fcol, sopac) {
    style.strokeColor = scol;
    style.strokeWidth = swidth;
    style.fillOpacity = fopac;
    if (fcol) style.fillColor = fcol;
    if (sopac) style.strokeOpacity = sopac;
    return style;
  };

  this.vVertexIcon = OpenLayers.Util.applyDefaults(
    {
      externalGraphic: 'assets/img/handle2.png',
      graphicWidth: 16,
      graphicHeight: 16,
      graphicOpacity: 0.2,
    },
    this.vertexIcon,
  );

  this.selStyle = {
    temporary: OpenLayers.Util.applyDefaults(
      {
        pointRadius: 0,
        strokeColor: this.colors.black,
        fillColor: this.colors.black,
        strokeOpacity: 0.7,
        fillOpacity: 0,
      },
      OpenLayers.Feature.Vector.style.temporary,
    ),
    default: OpenLayers.Util.applyDefaults(
      {
        strokeColor: this.colors.midgrey,
        strokeWidth: 2,
        fillColor: this.colors.midgrey,
        fillOpacity: 0.25,
        externalGraphic: 'assets/img/handle2.png',
        graphicOpacity: 0.6,
        graphicWidth: 16,
        graphicHeight: 16,
      },
      OpenLayers.Feature.Vector.style['default'],
    ),
    strokeColor: this.colors.midgrey,
    strokeWidth: 3,
    fillColor: this.colors.midgrey,
    fillOpacity: 0.45,
    strokeOpacity: 0.45,
  };

  this.defaultStyle = {
    temporary: OpenLayers.Util.applyDefaults(
      {
        pointRadius: 4,
        strokeWidth: 2,
        strokeColor: this.colors.black,
        fillColor: this.colors.black,
        strokeOpacity: 0.7,
        fillOpacity: 0,
      },
      OpenLayers.Feature.Vector.style.temporary,
    ),
    default: OpenLayers.Util.applyDefaults(
      {
        strokeColor: this.colors.red,
        strokeWidth: 2,
        fillColor: this.colors.red,
        fillOpacity: 0.25,
        externalGraphic: 'assets/img/handle2.png',
        graphicOpacity: 0.6,
        graphicWidth: 16,
        graphicHeight: 16,
      },
      OpenLayers.Feature.Vector.style['default'],
    ),
  };
  this.propertyStyle = {
    temporary: OpenLayers.Util.applyDefaults(
      {
        pointRadius: 0,
        strokeColor: this.colors.black,
        fillColor: this.colors.black,
        strokeOpacity: 0.7,
        fillOpacity: 0,
      },
      OpenLayers.Feature.Vector.style.temporary,
    ),
    default: OpenLayers.Util.applyDefaults(
      {
        strokeColor: this.colors.green,
        strokeWidth: 2,
        fillColor: this.colors.green,
        fillOpacity: 0.25,
        externalGraphic: 'assets/img/handle2.png',
        graphicOpacity: 0.6,
        graphicWidth: 16,
        graphicHeight: 16,
      },
      OpenLayers.Feature.Vector.style['default'],
    ),
  };
  this.wfsstyleMap = new OpenLayers.StyleMap({
    strokeColor: '#ff0000',
    strokeWidth: 1,
    strokeOpacity: 0,
    fillOpacity: 0,
  });
  this.layerStyleMap = new OpenLayers.StyleMap({
    strokeColor: '#ffff00',
    fillColor: '#00ffff',
    strokeWidth: 3,
    strokeOpacity: 1,
    fillOpacity: 0.3,
  });
  this.planningStyle = {
    default: OpenLayers.Util.applyDefaults(
      {
        strokeColor: this.colors.red,
        strokeWidth: 8,
        fillColor: this.colors.red,
        fillOpacity: 0.25,
        graphicOpacity: 0.6,
      },
      OpenLayers.Feature.Vector.style['default'],
    ),
  };
}
